import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { uxMessageActivityApi } from "./api";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { toast } from "@shared/ui/use-toast";
import { queryClient } from "@shared/api/queries/queryClient";

export const useGetMessageActivitySummary = () => {
  const utilityId = useRemoteUtilityId();
  return useSmartQuery(
    QueryKeyFactory.module.ux.messageActivity.getMessageActivitySummary(),
    () => uxMessageActivityApi.getMessageActivitySummary(utilityId),
    {
      enabled: !!utilityId,
    }
  );
};

export const useGetAllMessageActivity = (
  page?: any,
  limit?: any,
  search?: any
) => {
  const utilityId = useRemoteUtilityId();
  return useSmartQuery(
    QueryKeyFactory.module.ux.messageActivity.getAllMessageActivity(
      page,
      limit,
      search
    ),
    () => uxMessageActivityApi.getAllMessageActivity(utilityId, page, limit, search),
    {
      enabled: !!utilityId,
    }
  );
};

export const useGetMessageActivityById = (id: string) => {
  const utilityId = useRemoteUtilityId();
  return useSmartQuery(
    QueryKeyFactory.module.ux.messageActivity.getMessageActivityById(
      id
    ),
    () => uxMessageActivityApi.getMessageActivityById(id,utilityId),
    {
      enabled: !!utilityId || !!id,
    }
  );
};

export const useResendMessage = () => {
  return useSmartMutation(
    (payload: any) => uxMessageActivityApi.resendActivity(payload),
    {
      onSuccess: () => {
        toast({
          title: "Message Re-send",
          description: "Message Re-send successfully!",
          variant: "default",
        });
        queryClient.refetchQueries({
          queryKey: ["ux", "messageActivity", "messageActivityList"],
        });
        queryClient.refetchQueries({
          queryKey: ["ux", "messageActivity", "messageActivityDetails"],
        });
      },
      onError: (error: Error) => {
        toast({
          title: `Failed to Re-send Message`,
          description: `${error.message}`,
          variant: "destructive",
        });
      },
    }
  );
};
